import { nanoid } from "nanoid";

export function getTempMetricsId() {
  let tempMetricsId = sessionStorage.getItem('tempMetricsId');
  if (!tempMetricsId) {
    tempMetricsId = nanoid();
    sessionStorage.setItem('tempMetricsId', tempMetricsId);
  }
  return tempMetricsId;
}